module.exports = __webpack_public_path__ + "img/news_1_3.da5ca901.jpg";